export default __webpack_public_path__ + "static/media/change-status-icon.973e9464.svg";